import { render } from "./OrderHistView.vue?vue&type=template&id=4eea2260&scoped=true"
import script from "./OrderHistView.vue?vue&type=script&lang=js"
export * from "./OrderHistView.vue?vue&type=script&lang=js"

import "./OrderHistView.vue?vue&type=style&index=0&id=4eea2260&scoped=true&lang=css"
import "./OrderHistView.vue?vue&type=style&index=1&id=4eea2260&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eea2260"]])

export default __exports__